import React, { useState } from "react";
import Card from "./Card";
import Buttons from "./Buttons";
import Data from "./Data";
import { Container, Row, Col } from "react-bootstrap";

const MenuKedua = () => {
  const [item, setItem] = useState(Data);
  const menuItems = [...new Set(Data.map((Val) => Val.category))];

  const filterItem = (curcat) => {
    const newItem = Data.filter((newVal) => {
      return newVal.category === curcat;
    });
    setItem(newItem);
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <h1 className="col-12 text-center my-3 mt-3">myPortofolio.</h1>
        <Buttons
          filterItem={filterItem}
          setItem={setItem}
          menuItems={menuItems}
        />
        <Card item={item} />
      </div>
      <Container>
        <Row>
          <Col>
            <div className="bawah-judul">freeSpace.</div>
            <a
              className="social-media"
              href="https://www.instagram.com/freespace_id/"
              target="_blank"
            >
              instagram
            </a>
            <a
              className="social-media"
              href="https://github.com/hanhafizh"
              target="_blank"
            >
              github
            </a>
            {/* <a className="social-media" href="https://www.instagram.com/freespace_id/" target="_blank">discord</a> */}
            <h1 className="copyright">@2022 freeSpace</h1>
          </Col>
        </Row>
      </Container>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
    </div>
  );
};

export default MenuKedua;
